import React from 'react';
import { Container, Loader } from 'semantic-ui-react';
import ActionPanel from './ActionPanel';
import PendingActivationBanner from './components/PendingActivationBanner';
import UnsavedChangesGuard from './components/UnsavedChangesGuard';
import GroupedRuleList from './components/GroupedRuleList';
import {
  useEligibilityTheme,
  useEligibilityRules,
} from '../../hooks/useEligibilityEngine';
import './styles.css';

const EligibilityEnginePageView = () => {
  const { themeClass } = useEligibilityTheme();
  const { rules, isRulesLoading, rulesError } = useEligibilityRules();

  return (
    <div
      id='eligibility-engine-page'
      data-testid='eligibility-engine-page'
      className={`theme ${themeClass}`}
    >
      <UnsavedChangesGuard />
      <ActionPanel />
      <Container>
        <PendingActivationBanner />
        <div className='fields-container'>
          {isRulesLoading ? (
            <Loader
              active
              inline='centered'
              content='Loading rules...'
              data-testid='rules-loading'
            />
          ) : rulesError ? (
            <div data-testid='rules-error'>
              Error loading rules. Please try again.
            </div>
          ) : (
            <GroupedRuleList rules={rules} />
          )}
        </div>
      </Container>
    </div>
  );
};

export default EligibilityEnginePageView;
